import React, { useState, useEffect } from "react";

import HandleRequest from "../../services/HandleRequest";
import BirthdayList from "./BirthdayList";

export default function BirthdayModal() {
  const [birthdays, setBirthdays] = useState([]);

  useEffect(() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");

    HandleRequest()
      .postRequest("/api/v1/customers/birthdays", { date: `${mm}-${dd}` })
      .then((response) => {
        setBirthdays(response.data ?? []);
      })
      .catch((e) => {
        // eslint-disable-next-line no-console -- surface the failure; the modal only renders the empty state
        console.error(e);
      });
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#35424a",
        borderRadius: 10,
        padding: 10,
        margin: 55,
        color: "white",
        flex: 1,
        flexDirection: "row",
        height: "auto",
        width: "80%",
      }}
    >
      {birthdays.length ? (
        <BirthdayList birthdays={birthdays} />
      ) : (
        <h6>No hay Ningun Cumpleaños Hoy.</h6>
      )}
    </div>
  );
}
